<template>
  <a
    v-if="link"
    :href="link"
    :aria-label="label"
  >
    <svg
      :class="['c-icon', 'c-icon--link', `c-icon-${name}`, `c-icon--${size}`]"
      :style="styles"
      aria-hidden="true"
    >
      <use
        :href="`#c-icon-${name}`"
        :xlinkHref="`#c-icon-${name}`"
      />
    </svg>
  </a>
  <svg
    v-else
    :class="['c-icon', `c-icon-${name}`, `c-icon--${size}`]"
    :style="styles"
    aria-hidden="true"
  >
    <use
      :href="`#c-icon-${name}`"
      :xlinkHref="`#c-icon-${name}`"
    />
  </svg>
</template>

<script>
export default {
  name: 'c-icon',
  props: {
    name: {
      type: String,
      required: false,
      default: 'default'
    },
    size: {
      type: String,
      default: 'md'
    },
    color: {
      type: String,
      default: '#000'
    },
    link: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    styles() {
      return {
        color: this.color,
        fill: this.color,
      }
    }
  }
}
</script>

<style lang="scss">
.c-icon {
  &--ssm {
    height: 1rem;
    width: 1rem;
  }

  &--sm {
    height: 1.5rem;
    width: 1.5rem;
  }

  &--md {
    height: 1.7rem;
    width: 1.7rem;
  }

  &--lg {
    height: 2rem;
    width: 2rem;
  }

  &--xl {
    height: 2.5rem;
    width: 2.5rem;
  }

  &--xlg {
    height: 2.875rem;
    width: 2.875rem;
  }

  &--xxl {
    height: 3.5rem;
    width: 3.5rem;
  }
}
</style>
